import { get } from 'lodash';
import { createSelector } from 'reselect';
import { preferencesSelector } from '../authentication';
import { currentPath } from '../router';

// STATE SELECTORS
const tabs = state => state.admin.tabs;

export const currentTabSelector = createSelector(tabs, currentPath, preferencesSelector, (t, path, prefs) => {
    const rememberTab = get(prefs, `tabs.${path}`);
    return rememberTab || t.currentTab;
});
export const disabledTabsSelector = createSelector(tabs, t => t.disabled);



// WEBPACK FOOTER //
// ./src/selectors/admin/tabs.js